const Projects = ({ projectName, briefInfo, gitLink }) => {
  return (
    <article className="project-box flex h-full flex-col rounded-xl border border-white/10 bg-slate-900/70 p-6 text-left shadow-sm backdrop-blur transition-all duration-300 hover:-translate-y-1 hover:border-orange-400/40 hover:shadow-md hover:shadow-orange-500/10">
      <h3 className="!mb-0 !bg-transparent !text-xl !font-semibold !tracking-tight !text-white">
        {projectName}
      </h3>
      <p className="!mb-0 mt-4 flex-1 !bg-transparent !text-sm !leading-7 !text-slate-300">
        {briefInfo}
      </p>
      <a
        href={gitLink}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-6 inline-flex items-center justify-center gap-2 rounded-lg border border-orange-400/30 !bg-transparent px-4 py-2 !text-sm !font-medium !text-orange-300 transition-colors hover:!bg-orange-400 hover:!text-slate-950"
      >
        <i className="fa-brands fa-github !bg-transparent" aria-hidden="true"></i>
        GitHub
      </a>
    </article>
  );
};

export default Projects;
